module.exports = require('./lib/core/core');


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/core.js
// module id = 931
// module chunks = 0